<template>
  <SinglePartner />
</template>

<script>
import SinglePartner from '@/components/content/partners/EditSelectedPartner.vue'

export default {
  name: 'ContentPartnerVerification',
  components: { SinglePartner }
}
</script>

<style scoped>

</style>
